import { Fragment } from 'react';
import { services } from '~/ocab-services/services.constant';
import { RemoteAppointmentInformation } from '../components';
import { REMOTE_PROGRESS_BAR_ITEMS, REMOTE_EDIT_PROGRESS_BAR_ITEMS } from './progress-bar-items.config';
import { PATH_NAMES } from '../constants';

export const config = {
  v3: {
    PROGRESS_BAR_ITEMS: REMOTE_PROGRESS_BAR_ITEMS,
    EDIT_PROGRESS_BAR_ITEMS: REMOTE_EDIT_PROGRESS_BAR_ITEMS,
    editMode: {
      firstEditPagePath: PATH_NAMES.EDIT_DATE,
      hideEditDateTitle: true,
      hideGoBackButton: true,
    },
    selectDateTitle: 'Select a date',
    AboutYou: {
      YourDetails: {
        phoneNumberConfig: {
          extra: (
            <Fragment>
              <p>
                {'We\'ll send you a text to confirm your booking.'}
              </p>
            </Fragment>
          ),
        },
      },
    },
    ReviewForm: {
      hideShopDetails: true,
    },
    getSelectDateExternalPrevPath: envConfig => envConfig.services[services.HOME_SERVICES.name].landingPageUrl,
    subtitleComponent: ({ classNameForSubtitleWithLink }) => (
      <div className={classNameForSubtitleWithLink}>
        <p>Our appointments are carried out online so you can receive expert advice anywhere at a time that works for you.</p>
      </div>
    ),
    hideFilters: false,
    BookingReview: {
      hideShopDetails: true,
      hidePartnerDetails: true,
    },
    BookingInformation: {
      appointmentInformation: RemoteAppointmentInformation,
    },
  },
};
